(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 8318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(8164);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);




var SEO = function(param) {
    var title = param.title, description = param.description, pageTitle = param.pageTitle, nofollow = param.nofollow, noindex = param.noindex;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                title: title,
                description: description,
                noindex: noindex,
                nofollow: nofollow
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: pageTitle !== null && pageTitle !== void 0 ? pageTitle : title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 5172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var LocationIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "11",
        height: "10",
        viewBox: "0 0 11 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.66595 7.5L6.16595 6.5V3.929C7.02645 3.7055 7.66596 2.929 7.66596 2C7.66596 0.897 6.76895 0 5.66595 0C4.56295 0 3.66595 0.897 3.66595 2C3.66595 2.929 4.30545 3.7055 5.16595 3.929V6.5L5.66595 7.5ZM4.66595 2C4.66595 1.4485 5.11445 1 5.66595 1C6.21745 1 6.66595 1.4485 6.66595 2C6.66595 2.5515 6.21745 3 5.66595 3C5.11445 3 4.66595 2.5515 4.66595 2Z",
                fill: "#616161"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.79946 4.2815L7.53295 5.2455C8.82845 5.6035 9.66595 6.292 9.66595 7C9.66595 7.946 8.02345 9 5.66595 9C3.30845 9 1.66595 7.946 1.66595 7C1.66595 6.292 2.50345 5.6035 3.79945 5.245L3.53295 4.281C1.76445 4.77 0.665955 5.8115 0.665955 7C0.665955 8.682 2.86245 10 5.66595 10C8.46945 10 10.666 8.682 10.666 7C10.666 5.8115 9.56745 4.77 7.79946 4.2815Z",
                fill: "#616161"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LocationIcon);


/***/ }),

/***/ 6933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var PhoneIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "9",
        height: "12",
        viewBox: "0 0 9 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.7322 11.0604C2.99155 10.3164 -0.0292545 6.1065 0.719913 1.4088C0.768574 1.10157 1.05707 0.890985 1.36375 0.939558L2.83046 1.17186C3.10547 1.21542 3.30734 1.45469 3.30478 1.73335C3.2981 2.4015 3.38734 3.06715 3.56977 3.70995L3.60746 3.84235C3.63275 3.93143 3.62616 4.02655 3.58883 4.1113C3.55149 4.19605 3.48575 4.26511 3.40294 4.30657C2.8971 4.55905 2.62036 5.18439 2.89366 5.74935C3.23774 6.46068 3.70573 7.10505 4.27574 7.65229C4.72923 8.08633 5.40949 8.01638 5.80528 7.61378C5.87028 7.54761 5.95637 7.50624 6.04865 7.49683C6.14093 7.48742 6.2336 7.51057 6.31062 7.56226L6.42443 7.63838C6.97934 8.01102 7.58482 8.30169 8.22231 8.50176C8.48812 8.58543 8.6533 8.85136 8.60966 9.12692L8.37744 10.5931C8.36588 10.6661 8.34004 10.7361 8.3014 10.7991C8.26276 10.8621 8.21209 10.9169 8.15227 10.9603C8.09244 11.0037 8.02465 11.0349 7.95277 11.0521C7.88088 11.0693 7.80631 11.0722 7.73331 11.0606L7.7322 11.0604Z",
            fill: "#616161"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhoneIcon);


/***/ }),

/***/ 7810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_icons_asperand_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9885);
/* harmony import */ var _components_icons_instagram_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2143);
/* harmony import */ var _components_icons_location_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5172);
/* harmony import */ var _components_icons_phone_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6933);
/* harmony import */ var _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1537);
/* harmony import */ var _utils_constants_locations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8891);
/* harmony import */ var _utils_functions_general_functions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(337);
/* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7911);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9843);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_10__);











var AboutContact = function(param) {
    var contactInfo = param.contactInfo, outsideFilter = param.outsideFilter;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_6__/* .LocationEnum.CLUB */ .e.CLUB), filter = ref[0], setFilter = ref[1];
    var handleSetFilter = function(location) {
        setFilter(location);
    };
    var ref1 = contactInfo[outsideFilter !== null && outsideFilter !== void 0 ? outsideFilter : filter], street = ref1.street, postalCode = ref1.postalCode, city = ref1.city, country = ref1.country, phoneNumber = ref1.phoneNumber, email = ref1.email, googleMapLocation = ref1.googleMapLocation, instagram = ref1.instagram;
    var locations = (0,_utils_functions_general_functions__WEBPACK_IMPORTED_MODULE_8__/* .getObjectKeys */ .Zt)(contactInfo);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().aboutContact),
        children: [
            !outsideFilter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_filter__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                items: locations,
                hiddenItems: [
                    _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_6__/* .LocationEnum.HORS_LES_MURS */ .e.HORS_LES_MURS
                ],
                itemsColor: locations.map(function(location) {
                    return _utils_constants_locations__WEBPACK_IMPORTED_MODULE_7__/* .locationToColors */ .zL[location];
                }),
                filteredItems: [
                    filter
                ],
                handleSetFilter: handleSetFilter,
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().filter),
                mapToName: function(location) {
                    return _utils_constants_locations__WEBPACK_IMPORTED_MODULE_7__/* .locationToNames */ .yt[location];
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("address", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().contactInformation),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                street,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                postalCode,
                                " ",
                                city,
                                ", ",
                                country
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().externalUrls),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "tel:".concat(phoneNumber),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_phone_icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "mailto:".concat(email),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_asperand_icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: googleMapLocation,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_location_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: instagram,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_instagram_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AboutContact);


/***/ }),

/***/ 7911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _common_mainButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7749);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5163);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Filter = function(param) {
    var mapToName = param.mapToName, itemsColor = param.itemsColor, items = param.items, hiddenItems = param.hiddenItems, filteredItems = param.filteredItems, className = param.className, _relative = param.relative, relative = _relative === void 0 ? true : _relative, handleSetFilter = param.handleSetFilter;
    var filteredItemsSet = hiddenItems ? items.filter(function(item) {
        return !hiddenItems || !(hiddenItems === null || hiddenItems === void 0 ? void 0 : hiddenItems.includes(item));
    }) : items;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().query;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (query.tab) {
            filteredItemsSet.map(function(item) {
                if (mapToName(item) === query.tab) {
                    handleSetFilter(item);
                }
            });
        }
    }, [
        query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: [
            relative ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().relativeFilter) : (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().genericFilter),
            className, 
        ].join(" "),
        children: filteredItemsSet.map(function(item, i) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_mainButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: [
                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item),
                    filteredItems.includes(item) ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().selected) : null, 
                ].join(" "),
                onClick: function() {
                    handleSetFilter(item);
                },
                style: (itemsColor === null || itemsColor === void 0 ? void 0 : itemsColor[i]) ? {
                    color: itemsColor === null || itemsColor === void 0 ? void 0 : itemsColor[i]
                } : {},
                children: mapToName(item)
            }, i);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Filter);


/***/ }),

/***/ 8164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ about; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/api/clients/axios.ts
var axios = __webpack_require__(6912);
;// CONCATENATED MODULE: ./src/api/newsletter/subscribeToNewsletter.ts



var subscribeToNewsletter = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,axios/* sendRequest */.wG)({
                        method: "post",
                        url: "/newsletter/subscribe/",
                        data: input
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function subscribeToNewsletter(input) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/components/common/mainButton/index.tsx + 1 modules
var mainButton = __webpack_require__(7749);
// EXTERNAL MODULE: ./src/contexts/providers/breakpoint.tsx + 1 modules
var breakpoint = __webpack_require__(7380);
// EXTERNAL MODULE: ./src/contexts/providers/language.tsx
var providers_language = __webpack_require__(9327);
// EXTERNAL MODULE: ./src/localization/en.ts
var en = __webpack_require__(1257);
// EXTERNAL MODULE: ./src/localization/fr.ts
var fr = __webpack_require__(1916);
// EXTERNAL MODULE: ./src/components/about/footer/index.module.scss
var index_module = __webpack_require__(7085);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/about/footer/index.tsx










var AboutFooter = function() {
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var breakPoint = (0,breakpoint/* useBreakpoint */.G)();
    var isDesktop = breakPoint === "desktop" || breakPoint === "widescreen";
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var aboutFooterTexts = language === "En" ? en/* default.aboutPage.footer */.Z.aboutPage.footer : fr/* default.aboutPage.footer */.Z.aboutPage.footer;
    var handleInputChange = function(e) {
        setEmail(e.target.value);
    };
    var ref1 = (0,es.useMutation)(subscribeToNewsletter, {
        onSuccess: function() {
            setEmail("");
        }
    }), subscribeToNewsletterMutation = ref1.mutate, subscribeToNewsletterLoading = ref1.isLoading;
    var handleSubmitNewsletter = function() {
        subscribeToNewsletterMutation({
            email: email
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (index_module_default()).aboutFooter,
        children: [
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: aboutFooterTexts.copyRights
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (index_module_default()).subscribeToNewsletter,
                onSubmit: function(e) {
                    return e.preventDefault();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        children: isDesktop ? aboutFooterTexts.subscribe : "Newsletter"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "email",
                        placeholder: "Entrez votre email",
                        size: 16,
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                        onClick: handleSubmitNewsletter,
                        isLoading: subscribeToNewsletterLoading,
                        children: aboutFooterTexts.apply
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "\xa92022 Silencio Tous droits r\xe9serv\xe9s."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Website design by ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.hervethomas.com/",
                                children: "THS"
                            }),
                            " — Development by ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://poyesis.fr/",
                                children: "Poyesis"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var footer = (AboutFooter);

;// CONCATENATED MODULE: ./src/components/about/introduction/index.tsx




var AboutIntroduction = function() {
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var aboutText = language === "En" ? en/* default.aboutPage.intro */.Z.aboutPage.intro : fr/* default.aboutPage.intro */.Z.aboutPage.intro;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "p-1 bbg pt-h",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "description",
            children: aboutText
        })
    });
};
/* harmony default export */ var introduction = (AboutIntroduction);

// EXTERNAL MODULE: ./src/components/SEO/index.tsx
var SEO = __webpack_require__(7353);
// EXTERNAL MODULE: ./src/components/ui/contact/index.tsx
var contact = __webpack_require__(7810);
;// CONCATENATED MODULE: ./src/pages/about/index.tsx





var AboutPage = function(param) {
    var contactInfo = param.contactInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Silencio - \xc0 propos de",
                description: "Ses lieux confidentiels, d\xe9di\xe9s aux arts et \xe0 la f\xeate, font de lui un rendez-vous incontournable qui r\xe9unit les artistes et les cr\xe9atifs. ",
                nofollow: false,
                noindex: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(introduction, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact/* default */.Z, {
                contactInfo: contactInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var about = (AboutPage);


/***/ }),

/***/ 1537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ LocationEnum; }
/* harmony export */ });
var LocationEnum;
(function(LocationEnum) {
    LocationEnum["CLUB"] = "CLUB";
    LocationEnum["DES_PRES"] = "DES_PRES";
    LocationEnum["NYC"] = "NYC";
    LocationEnum["IBIZA"] = "IBIZA";
    LocationEnum["HORS_LES_MURS"] = "HORS_LES_MURS";
})(LocationEnum || (LocationEnum = {}));


/***/ }),

/***/ 8891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kl": function() { return /* binding */ locations; },
/* harmony export */   "yt": function() { return /* binding */ locationToNames; },
/* harmony export */   "zL": function() { return /* binding */ locationToColors; }
/* harmony export */ });
/* harmony import */ var _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1537);

var locations = [
    _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__/* .LocationEnum.CLUB */ .e.CLUB,
    _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__/* .LocationEnum.DES_PRES */ .e.DES_PRES,
    _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__/* .LocationEnum.NYC */ .e.NYC,
    _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__/* .LocationEnum.IBIZA */ .e.IBIZA,
    _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__/* .LocationEnum.HORS_LES_MURS */ .e.HORS_LES_MURS, 
];
var locationToNames = {
    CLUB: "Silencio",
    IBIZA: "El Silencio",
    HORS_LES_MURS: "Silencio Hors Les Murs",
    NYC: "Silencio NYC",
    DES_PRES: "Silencio Des Pr\xe9s"
};
var locationToColors = {
    CLUB: "#AD9462",
    IBIZA: "#D8895D",
    HORS_LES_MURS: "#A2A1A1",
    NYC: "#FF0000",
    DES_PRES: "#4575D3"
};


/***/ }),

/***/ 7085:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"aboutFooter":"footer_aboutFooter__J5ikW","subscribeToNewsletter":"footer_subscribeToNewsletter__dxEwN"};

/***/ }),

/***/ 9843:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"aboutContact":"contact_aboutContact__DtBEq","filter":"contact_filter__ZwrLF","contactInformation":"contact_contactInformation__XY3o5","externalUrls":"contact_externalUrls__oQuWN","contact":"contact_contact__cJUyp","contactsContainer":"contact_contactsContainer__6T97B"};

/***/ }),

/***/ 5163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"genericFilter":"filter_genericFilter__JP4qD","item":"filter_item__lC9f4","selected":"filter_selected__JKwVc","relativeFilter":"filter_relativeFilter__3Lx9m"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [962,774,888,179], function() { return __webpack_exec__(8318); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);